import React from 'react'

const SvgChatFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 4a2 2 0 012-2h16a2 2 0 012 2v18l-6-4H4a2 2 0 01-2-2V4zm6 7a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z'
    />
  </svg>
)

export default SvgChatFilled
